import UserEdit from './UserEdit.container';

export default UserEdit;
